import { useOutsideClick as rooksUseOutsideClick } from 'rooks';

type UseOutsideClickProps = Parameters<typeof rooksUseOutsideClick>;

export const useOutsideClick = (ref: UseOutsideClickProps['0'], outsideClickCallback: UseOutsideClickProps['1']) => {
  rooksUseOutsideClick(ref, outsideClickCallback);
};
